module.exports = __webpack_public_path__ + "img/activeIndex1.f9380fe8.png";